export async function markDesktopAuthComplete(desktopToken: string): Promise<boolean> {
  try {
    const response = await fetch("/api/ss/auth/desktop/complete", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ desktop_token: desktopToken }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
